<app-tree-table
  [actionColumnWidth]="700"
  [columns]="columns"
  [firstColumnFrozen]="true"
  [loading]="loading"
  [value]="tree"
  filename="MENU.CATEGORIES"
  sortField="sortNumber">
  <ng-template
    (onClick)="menu.toggle($event)"
    appToolbarButton
    icon="fal fa-plus"
    labelKey="CATEGORIES.ADD_CATEGORY"></ng-template>

  <ng-template
    (onClick)="showMandanten($event.row)"
    appActionButton
    icon="fal fa-eye"
    labelKey="CATEGORIES.SHOW_CLIENTS"></ng-template>
  <ng-template
    (onClick)="createNewSubCategory($event.row)"
    appActionButton
    displayIf="node.data._isParent"
    icon="fal fa-plus"
    labelKey="CATEGORIES.CREATE_CATEGORY_BUTTON"
    type="secondary"></ng-template>
  <ng-template
    (onClick)="deleteCategory($event.row)"
    appActionButton
    displayIfNot="node.data.isInUse"
    icon="fal fa-trash"
    labelKey="CATEGORIES.DELETE_HEADER"
    type="danger"></ng-template>
</app-tree-table>

<p-menu [model]="items" [popup]="true" #menu></p-menu>

<p-dialog
  [(visible)]="displayDialog"
  [closable]="true"
  [closeOnEscape]="true"
  [maximizable]="true"
  [modal]="true"
  [style]="{ height: '90%', width: '900px' }">
  <p-header translate>MENU.MANDANTS</p-header>
  <app-table
    [columns]="mandantenColumns"
    [style]="{ height: '100%' }"
    [value]="mandanten"
    filename="MENU.MANDANTS"
    sortField="mandantId"></app-table>
</p-dialog>
